export const ATM_TYPES = [
  { value: 'ATM_CASH', label: 'ATM Cash' },
  { value: 'ATM_FROM_PROFIT', label: 'ATM From Profit' },
  { value: 'ATM_DIDNT_USE', label: 'ATM Didn’t Use' },
  { value: 'ATM_ADV', label: 'ATM Adv' },
];

export const PDF_COLORS = {
  BLUE_HEADER:  [75, 86, 210],
  GREEN_IN:     [22, 163, 74],
  RED_OUT:      [220, 38, 38],
  ORANGE_EXP:   [234, 88, 12],
  PURPLE_PCT:   [124, 58, 237],
  TEAL_CUST:    [13, 148, 136],
  BLUE_SECTION: [37, 99, 235],
  DARK_TEXT:     [33, 33, 33],
  GRAY_TEXT:     [102, 102, 102],
  LIGHT_BG:     [245, 247, 250],
  WHITE:        [255, 255, 255],
  BALANCE_BG:   [235, 240, 255],
  DARK_NAVY:    [26, 47, 90],
};